import React from 'react';
import { Field } from 'formik';

import InputField from 'buyside/components/presentation/Form/Field/InputField/inputField';
import PDFIcon from 'buyside/svgs/document/file-pdf.svg';
import { profileUrl } from 'buyside/util/urlHelper';
import { useIsMobile } from 'buyside/util/hooks/useIsMobile';

import styles from './jobApplicationCardStyles';

const JobApplicationCard = ({ currentUser: { displayName, profile } }) => {
  const isMobile = useIsMobile();

  const resume = profile.resume ? JSON.parse(profile.resume) : null;

  return (
    <div className={`${styles.cardContainer} ${styles.container}`}>
      <div className={styles.header}>{displayName}</div>
      <div className={`${styles.content} ${isMobile ? styles.responsiveContent : ''}`}>
        <div className={`${styles.fields} ${isMobile ? styles.fieldsResponsive : ''}`}>
          {resume && (
            <a
              className={styles.resumeLink}
              href={resume.url}
              download
              rel="noopener noreferrer"
              target="_blank"
            >
              <PDFIcon className={styles.icon} />
              View Resume
            </a>
          )}

          <div className={styles.inputs}>
            <Field component={InputField} type="tel" name="phone" label="phone:" />
            <Field component={InputField} type="email" name="email" label="email:" />
          </div>
        </div>

        <div className={styles.iframeContainer}>
          {(resume && <iframe width="100%" src={resume.url} />) || (
            <div className={styles.profileLinkContainer}>
              There was an error fetching your resume. Please re-upload resume on your{' '}
              <a className={styles.profileLink} href={profileUrl(profile.id)}>
                user profile page
              </a>
              .
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default JobApplicationCard;
